// src/components/player-profile/MiniStatsBar.js
//
// Extracted from inline closure in PlayerProfileModal.js per IMPORTANT
// batch 8 commit 8a (refactor only — no behavior change).
//
// Closure-→-prop conversion: parent's `player` and `isPitcher`
// promoted to declared props.
//
// Helper handling:
//   - formatAvg + formatEra + formatWhip rename-alias wrappers deleted
//     in 8k.2b; call sites now use canonical formatBattingAvg /
//     formatERA / formatBattingAvg(whip) directly from
//     services/statFormatUtils (cross-codebase rename-alias
//     consolidation per §14.test-infra.4 revised disposition).
import React from 'react';
import { formatBattingAvg, formatERA } from '../../services/statFormatUtils';
import { dynastyTheme } from '../../services/colorService';

const MiniStatsBar = ({ player, isPitcher }) => {
  const season = player?.stats?.season;
  if (!season) return null;

  const pitcher = isPitcher();
  const stats = pitcher ? season.pitching || {} : season.hitting || {};

  const items = pitcher
    ? [
        { label: 'ERA', value: formatERA(stats.era) },
        { label: 'W', value: stats.wins || 0 },
        { label: 'SV', value: stats.saves || 0 },
        { label: 'K', value: stats.strikeouts_pitched || 0 },
        { label: 'WHIP', value: formatBattingAvg(stats.whip) },
        { label: 'IP', value: stats.innings_pitched ? stats.innings_pitched.toFixed(1) : '0.0' },
        { label: 'QS', value: stats.quality_starts || 0 },
        { label: 'GP', value: stats.games_played || 0 },
      ]
    : [
        { label: 'AVG', value: formatBattingAvg(stats.batting_avg) },
        { label: 'HR', value: stats.home_runs || 0 },
        { label: 'RBI', value: stats.rbi || 0 },
        { label: 'R', value: stats.runs || 0 },
        { label: 'H', value: stats.hits || 0 },
        { label: 'SB', value: stats.stolen_bases || 0 },
        { label: 'OPS', value: formatBattingAvg(stats.ops) },
        { label: 'GP', value: stats.games_played || 0 },
      ];

  return (
    <div className="flex items-center justify-center gap-1 px-4 py-1.5 border-b border-neutral-700/50 bg-neutral-800/30">
      {items.map((item, i) => (
        <React.Fragment key={item.label}>
          {i > 0 && <span className="text-neutral-600 mx-0.5">|</span>}
          <span className={`text-xs ${dynastyTheme.classes.text.neutralLight}`}>{item.label}</span>
          <span className={`text-xs font-semibold ${dynastyTheme.classes.text.white} ml-0.5`}>{item.value}</span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default MiniStatsBar;
